import { computed, shallowRef } from 'vue';
import { useEventListener } from '@vueuse/core';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import { usePolicy } from 'dashboard/composables/usePolicy';

const HOST_READY_EVENT = 'hkele:chatwoot-extension-host-ready';
const PAGES_CHANGED_EVENT = 'hkele:chatwoot-settings-pages-changed';

export function useExtensionSettingsPages() {
  const { accountId } = useAccount();
  const user = useMapGetter('getCurrentUser');
  const { checkPermissions } = usePolicy();
  const registrations = shallowRef([]);
  const refresh = () => {
    registrations.value = window.ChatwootExtensions?.getSettingsPages?.() || [];
  };
  useEventListener(window, HOST_READY_EVENT, refresh);
  useEventListener(window, PAGES_CHANGED_EVENT, refresh);
  refresh();

  const pages = computed(() => {
    const membership = user.value.accounts?.find(
      account => Number(account.id) === accountId.value
    );
    if (membership?.status !== 'active') return [];
    return registrations.value.filter(page =>
      checkPermissions(page.permissions)
    );
  });
  const context = computed(() => ({ accountId: accountId.value }));

  return { pages, context };
}
